__turbopack_context__.v({
  "MarqueeLogoWrapper": "LogosMarquee-module-scss-module__pWBtDq__MarqueeLogoWrapper",
});
